import React from 'react';
import { SiAndroidstudio } from 'react-icons/si';
import styled from 'styled-components';
import PText from './PText';

const ItemStyles = styled.div`
  text-align: center;
  .stacksItem__icon {
    svg {
      width: 4rem;
    }
  }
  .stacksItem__title {
    font-size: 2.5rem;
    font-family: 'Montserrat SemiBold';
  }
  .stacksItem {
    margin-top: 2rem;
  }
`;

export default function StacksSectionItem({
  icon = <SiAndroidstudio />,
  title = 'Web Design',
  desc = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's ok",
}) {
  return (
    <ItemStyles className="stacksItem">
      <div className="stacksItem__icon">{icon}</div>
      <div className="stacksItem__title">{title}</div>
      <PText>{desc}</PText>
    </ItemStyles>
  );
}
